import { appApiUrl, appBaseUrl } from "../config/appConfig";
export const apiUrl = appApiUrl;
export const baseUrl = appBaseUrl;

